import React from "react";
import Icon from "../IconsSelector";
import * as S from "./ToolTip.styles";

interface IToolTip {
  title?: string;
  data: string;
  bgColor?: string;
  borderColor?: string;
  color?: string;
  iconName?: string;
  showIcon?: boolean;
  beforeLeft?: string;
  top?: string;
}

const ToolTipUI: React.FC<IToolTip> = ({
  title = "",
  data = "",
  bgColor = "",
  borderColor = "",
  color = "",
  iconName = "LobIcon",
  showIcon = true,
  beforeLeft = '3rem',
  top = '2.6rem'
}) => {
  return (
    <S.TooltipWrapper bgColor={bgColor} borderColor={borderColor} beforeLeft={beforeLeft} top={top}>
      {title ? (
        <S.CabTitle color={color}>
          {showIcon ? (
            <Icon
              name={iconName}
              styleProps={{ width: "1.8rem", height: "1.8rem", fill: color }}
            />
          ) : null}
          <span className="cabName">{title}</span>
        </S.CabTitle>
      ) : null}
      <S.CabDesc
        dangerouslySetInnerHTML={{
          __html: data,
        }}
      ></S.CabDesc>
    </S.TooltipWrapper>
  );
};

export default ToolTipUI;
